"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var RatesEntity_1 = __importDefault(require("./Entity/RatesEntity"));
var RatesApi = /** @class */ (function () {
    function RatesApi(session) {
        this.ratesEntity = new RatesEntity_1.default(session);
    }
    RatesApi.prototype.getRates = function (params) {
        return this.ratesEntity.getRates(params);
    };
    RatesApi.prototype.postRates = function (payload) {
        return this.ratesEntity.postRates(payload);
    };
    RatesApi.prototype.importRateCardTerms = function (payload) {
        var formData = new FormData();
        formData.append('file', payload.file);
        formData.append('entity_id', payload.entity_id.toString());
        formData.append('term_type', payload.term_type);
        formData.append('options', JSON.stringify(payload.options));
        return this.ratesEntity.importRateCardTerms(formData);
    };
    RatesApi.prototype.exportRateCardTerms = function (payload) {
        return this.ratesEntity.exportRateCardTerms(payload);
    };
    RatesApi.prototype.exportMasterRateCardTerms = function (payload) {
        return this.ratesEntity.exportMasterRateCardTerms(payload);
    };
    return RatesApi;
}());
exports.default = RatesApi;
//# sourceMappingURL=RatesApi.js.map